/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BulkCardPatch,
  BulkDeleteIds,
  BulkDeleteResult,
  Card,
  CardHashIngestResponse,
  CardHashMatchResponse,
  CardPatch,
  CardVisionResult,
  DemandResult,
  EbayNotConnectedResponse,
  EndListingInput,
  EndListingResult,
  ErrorResponse,
  ExtendDurationInput,
  ExtendDurationResult,
  GetEbayDemandParams,
  HealthStatus,
  IdentifyCardWithVisionBody,
  IngestCardHashesBody,
  ListingMessagesResult,
  ListingState,
  Lot,
  LotPatch,
  MatchCardByHashBody,
  RelistFromListingInput,
  RelistFromListingResult,
  ReplyToMessageInput,
  ReplyToMessageResult,
  ReviseDetailsInput,
  ReviseDetailsResult,
  RevisePriceInput,
  RevisePriceResult,
  SendOfferInput,
  SendOfferResult,
  SortingBin,
  SortingBinPatch,
  StorageBin,
  StorageBinPatch
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;




export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, }

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetEbayListingStateUrl = (itemId: string,) => {




  return `/api/ebay/listings/${itemId}`
}

/**
 * Returns the current price fields, bid count, and end time of an active eBay listing. Used by the price editor to pre-fill real values and to decide which fields can still be revised.
 *
 * @summary Fetch live state of an eBay listing
 */
export const getEbayListingState = async (itemId: string, options?: RequestInit): Promise<ListingState> => {

  return customFetch<ListingState>(getGetEbayListingStateUrl(itemId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEbayListingStateQueryKey = (itemId: string,) => {
    return [
    `/api/ebay/listings/${itemId}`
    ] as const;
    }


export const getGetEbayListingStateQueryOptions = <TData = Awaited<ReturnType<typeof getEbayListingState>>, TError = ErrorType<EbayNotConnectedResponse | ErrorResponse>>(itemId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEbayListingState>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEbayListingStateQueryKey(itemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEbayListingState>>> = ({ signal }) => getEbayListingState(itemId, { signal });





   return  { queryKey, queryFn, enabled: itemId !== null && itemId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEbayListingState>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEbayListingStateQueryResult = NonNullable<Awaited<ReturnType<typeof getEbayListingState>>>
export type GetEbayListingStateQueryError = ErrorType<EbayNotConnectedResponse | ErrorResponse>


/**
 * @summary Fetch live state of an eBay listing
 */

export function useGetEbayListingState<TData = Awaited<ReturnType<typeof getEbayListingState>>, TError = ErrorType<EbayNotConnectedResponse | ErrorResponse>>(
 itemId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEbayListingState>>, TError, TData>, }

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEbayListingStateQueryOptions(itemId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getReviseEbayListingPriceUrl = () => {




  return `/api/ebay/listings/revise-price`
}

/**
 * Revises the price fields (Buy It Now / starting bid / reserve) of an active eBay listing in place via the Trading API ReviseItem call. Which fields are accepted depends on the listing type. eBay enforces its own rules (e.g. starting bid can't be lowered once bids exist) and will return validation errors that are surfaced as 400 responses.
 *
 * @summary Revise price fields on an active eBay listing
 */
export const reviseEbayListingPrice = async (revisePriceInput: RevisePriceInput, options?: RequestInit): Promise<RevisePriceResult> => {

  return customFetch<RevisePriceResult>(getReviseEbayListingPriceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(revisePriceInput)
  }
);}




export const getReviseEbayListingPriceMutationOptions = <TError = ErrorType<ErrorResponse | EbayNotConnectedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviseEbayListingPrice>>, TError,{data: BodyType<RevisePriceInput>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reviseEbayListingPrice>>, TError,{data: BodyType<RevisePriceInput>}, TContext> => {

const mutationKey = ['reviseEbayListingPrice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviseEbayListingPrice>>, {data: BodyType<RevisePriceInput>}> = (props) => {
          const {data} = props ?? {};

          return  reviseEbayListingPrice(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviseEbayListingPriceMutationResult = NonNullable<Awaited<ReturnType<typeof reviseEbayListingPrice>>>
    export type ReviseEbayListingPriceMutationBody = BodyType<RevisePriceInput>
    export type ReviseEbayListingPriceMutationError = ErrorType<ErrorResponse | EbayNotConnectedResponse>

    /**
 * @summary Revise price fields on an active eBay listing
 */
export const useReviseEbayListingPrice = <TError = ErrorType<ErrorResponse | EbayNotConnectedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviseEbayListingPrice>>, TError,{data: BodyType<RevisePriceInput>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof reviseEbayListingPrice>>,
        TError,
        {data: BodyType<RevisePriceInput>},
        TContext
      > => {
      return useMutation(getReviseEbayListingPriceMutationOptions(options));
    }

export const getReviseEbayListingDetailsUrl = () => {




  return `/api/ebay/listings/revise-details`
}

/**
 * Revises the title and/or description of an active eBay listing in place via the Trading API ReviseItem call. eBay enforces its own rules — for example, the title cannot be changed once the auction has bids or in the final 12 hours of an auction; descriptions can usually be revised at any point. Validation errors from eBay are surfaced as 400 responses.
 *
 * @summary Revise the title and/or description of an active eBay listing
 */
export const reviseEbayListingDetails = async (reviseDetailsInput: ReviseDetailsInput, options?: RequestInit): Promise<ReviseDetailsResult> => {

  return customFetch<ReviseDetailsResult>(getReviseEbayListingDetailsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reviseDetailsInput)
  }
);}




export const getReviseEbayListingDetailsMutationOptions = <TError = ErrorType<ErrorResponse | EbayNotConnectedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviseEbayListingDetails>>, TError,{data: BodyType<ReviseDetailsInput>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reviseEbayListingDetails>>, TError,{data: BodyType<ReviseDetailsInput>}, TContext> => {

const mutationKey = ['reviseEbayListingDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviseEbayListingDetails>>, {data: BodyType<ReviseDetailsInput>}> = (props) => {
          const {data} = props ?? {};

          return  reviseEbayListingDetails(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviseEbayListingDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof reviseEbayListingDetails>>>
    export type ReviseEbayListingDetailsMutationBody = BodyType<ReviseDetailsInput>
    export type ReviseEbayListingDetailsMutationError = ErrorType<ErrorResponse | EbayNotConnectedResponse>

    /**
 * @summary Revise the title and/or description of an active eBay listing
 */
export const useReviseEbayListingDetails = <TError = ErrorType<ErrorResponse | EbayNotConnectedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviseEbayListingDetails>>, TError,{data: BodyType<ReviseDetailsInput>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof reviseEbayListingDetails>>,
        TError,
        {data: BodyType<ReviseDetailsInput>},
        TContext
      > => {
      return useMutation(getReviseEbayListingDetailsMutationOptions(options));
    }

export const getSendEbayOfferToWatchersUrl = () => {




  return `/api/ebay/listings/send-offer`
}

/**
 * Sends a Seller-Initiated Offer to all interested buyers (watchers) of a fixed-price eBay listing via the Negotiation API sendOfferToInterestedBuyers call. Requires the listing to be Buy It Now (auctions are not supported by this API), have at least one watcher, and meet eBay's eligibility criteria (e.g. listing must be a fixed-price item active for at least a few hours). Returns the number of watchers the offer was sent to.
 *
 * @summary Send a discounted offer to watchers of a Buy It Now listing
 */
export const sendEbayOfferToWatchers = async (sendOfferInput: SendOfferInput, options?: RequestInit): Promise<SendOfferResult> => {

  return customFetch<SendOfferResult>(getSendEbayOfferToWatchersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sendOfferInput)
  }
);}




export const getSendEbayOfferToWatchersMutationOptions = <TError = ErrorType<ErrorResponse | EbayNotConnectedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEbayOfferToWatchers>>, TError,{data: BodyType<SendOfferInput>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendEbayOfferToWatchers>>, TError,{data: BodyType<SendOfferInput>}, TContext> => {

const mutationKey = ['sendEbayOfferToWatchers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendEbayOfferToWatchers>>, {data: BodyType<SendOfferInput>}> = (props) => {
          const {data} = props ?? {};

          return  sendEbayOfferToWatchers(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendEbayOfferToWatchersMutationResult = NonNullable<Awaited<ReturnType<typeof sendEbayOfferToWatchers>>>
    export type SendEbayOfferToWatchersMutationBody = BodyType<SendOfferInput>
    export type SendEbayOfferToWatchersMutationError = ErrorType<ErrorResponse | EbayNotConnectedResponse>

    /**
 * @summary Send a discounted offer to watchers of a Buy It Now listing
 */
export const useSendEbayOfferToWatchers = <TError = ErrorType<ErrorResponse | EbayNotConnectedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEbayOfferToWatchers>>, TError,{data: BodyType<SendOfferInput>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendEbayOfferToWatchers>>,
        TError,
        {data: BodyType<SendOfferInput>},
        TContext
      > => {
      return useMutation(getSendEbayOfferToWatchersMutationOptions(options));
    }

export const getExtendEbayListingDurationUrl = () => {




  return `/api/ebay/listings/extend-duration`
}

/**
 * Revises the ListingDuration of an active eBay listing in place via the Trading API ReviseItem call. eBay enforces its own rules (e.g. auctions cannot be extended once they have bids or in their final 12 hours; certain durations are only valid for certain listing formats). Validation errors from eBay are surfaced as 400 responses.
 *
 * @summary Change the listing duration of an active eBay listing
 */
export const extendEbayListingDuration = async (extendDurationInput: ExtendDurationInput, options?: RequestInit): Promise<ExtendDurationResult> => {

  return customFetch<ExtendDurationResult>(getExtendEbayListingDurationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(extendDurationInput)
  }
);}




export const getExtendEbayListingDurationMutationOptions = <TError = ErrorType<ErrorResponse | EbayNotConnectedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extendEbayListingDuration>>, TError,{data: BodyType<ExtendDurationInput>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof extendEbayListingDuration>>, TError,{data: BodyType<ExtendDurationInput>}, TContext> => {

const mutationKey = ['extendEbayListingDuration'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof extendEbayListingDuration>>, {data: BodyType<ExtendDurationInput>}> = (props) => {
          const {data} = props ?? {};

          return  extendEbayListingDuration(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExtendEbayListingDurationMutationResult = NonNullable<Awaited<ReturnType<typeof extendEbayListingDuration>>>
    export type ExtendEbayListingDurationMutationBody = BodyType<ExtendDurationInput>
    export type ExtendEbayListingDurationMutationError = ErrorType<ErrorResponse | EbayNotConnectedResponse>

    /**
 * @summary Change the listing duration of an active eBay listing
 */
export const useExtendEbayListingDuration = <TError = ErrorType<ErrorResponse | EbayNotConnectedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extendEbayListingDuration>>, TError,{data: BodyType<ExtendDurationInput>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof extendEbayListingDuration>>,
        TError,
        {data: BodyType<ExtendDurationInput>},
        TContext
      > => {
      return useMutation(getExtendEbayListingDurationMutationOptions(options));
    }

export const getRelistEbayListingUrl = () => {




  return `/api/ebay/listings/relist-from-listing`
}

/**
 * Looks up an existing eBay listing (typically one that has ended) and creates a brand new listing reusing its photos, description, duration, and shipping. Used for the bulk relist action so the seller doesn't have to fill in the Go Live form per listing.
 *
 * @summary Create a new eBay listing carrying forward an old listing's data
 */
export const relistEbayListing = async (relistFromListingInput: RelistFromListingInput, options?: RequestInit): Promise<RelistFromListingResult> => {

  return customFetch<RelistFromListingResult>(getRelistEbayListingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(relistFromListingInput)
  }
);}




export const getRelistEbayListingMutationOptions = <TError = ErrorType<ErrorResponse | EbayNotConnectedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof relistEbayListing>>, TError,{data: BodyType<RelistFromListingInput>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof relistEbayListing>>, TError,{data: BodyType<RelistFromListingInput>}, TContext> => {

const mutationKey = ['relistEbayListing'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof relistEbayListing>>, {data: BodyType<RelistFromListingInput>}> = (props) => {
          const {data} = props ?? {};

          return  relistEbayListing(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RelistEbayListingMutationResult = NonNullable<Awaited<ReturnType<typeof relistEbayListing>>>
    export type RelistEbayListingMutationBody = BodyType<RelistFromListingInput>
    export type RelistEbayListingMutationError = ErrorType<ErrorResponse | EbayNotConnectedResponse>

    /**
 * @summary Create a new eBay listing carrying forward an old listing's data
 */
export const useRelistEbayListing = <TError = ErrorType<ErrorResponse | EbayNotConnectedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof relistEbayListing>>, TError,{data: BodyType<RelistFromListingInput>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof relistEbayListing>>,
        TError,
        {data: BodyType<RelistFromListingInput>},
        TContext
      > => {
      return useMutation(getRelistEbayListingMutationOptions(options));
    }

export const getGetEbayListingMessagesUrl = (itemId: string,) => {




  return `/api/ebay/listings/${itemId}/messages`
}

/**
 * Returns the buyer messages (questions, comments) sent on a specific eBay listing via the Trading API GetMemberMessages call, sorted oldest first. Each message includes the eBay user id of the sender, the message body, when it was received, and whether the seller has marked it read in eBay's UI. Used to render the per-listing thread view and the unread-message badge on Live cards.
 *
 * @summary List buyer messages on an active eBay listing
 */
export const getEbayListingMessages = async (itemId: string, options?: RequestInit): Promise<ListingMessagesResult> => {

  return customFetch<ListingMessagesResult>(getGetEbayListingMessagesUrl(itemId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEbayListingMessagesQueryKey = (itemId: string,) => {
    return [
    `/api/ebay/listings/${itemId}/messages`
    ] as const;
    }


export const getGetEbayListingMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getEbayListingMessages>>, TError = ErrorType<EbayNotConnectedResponse | ErrorResponse>>(itemId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEbayListingMessages>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEbayListingMessagesQueryKey(itemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEbayListingMessages>>> = ({ signal }) => getEbayListingMessages(itemId, { signal });





   return  { queryKey, queryFn, enabled: itemId !== null && itemId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEbayListingMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEbayListingMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getEbayListingMessages>>>
export type GetEbayListingMessagesQueryError = ErrorType<EbayNotConnectedResponse | ErrorResponse>


/**
 * @summary List buyer messages on an active eBay listing
 */

export function useGetEbayListingMessages<TData = Awaited<ReturnType<typeof getEbayListingMessages>>, TError = ErrorType<EbayNotConnectedResponse | ErrorResponse>>(
 itemId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEbayListingMessages>>, TError, TData>, }

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEbayListingMessagesQueryOptions(itemId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getReplyToEbayListingMessageUrl = (itemId: string,) => {




  return `/api/ebay/listings/${itemId}/messages/reply`
}

/**
 * Sends a reply to a buyer's message about an active listing via the Trading API AddMemberMessageRTQ call. The reply is delivered through eBay's messaging system and shows up in the buyer's My eBay messages inbox. The parent message id and the buyer's user id must come from a prior GetMemberMessages response.
 *
 * @summary Reply to a buyer's message on an eBay listing
 */
export const replyToEbayListingMessage = async (itemId: string,
    replyToMessageInput: ReplyToMessageInput, options?: RequestInit): Promise<ReplyToMessageResult> => {

  return customFetch<ReplyToMessageResult>(getReplyToEbayListingMessageUrl(itemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(replyToMessageInput)
  }
);}




export const getReplyToEbayListingMessageMutationOptions = <TError = ErrorType<ErrorResponse | EbayNotConnectedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replyToEbayListingMessage>>, TError,{itemId: string;data: BodyType<ReplyToMessageInput>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof replyToEbayListingMessage>>, TError,{itemId: string;data: BodyType<ReplyToMessageInput>}, TContext> => {

const mutationKey = ['replyToEbayListingMessage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replyToEbayListingMessage>>, {itemId: string;data: BodyType<ReplyToMessageInput>}> = (props) => {
          const {itemId,data} = props ?? {};

          return  replyToEbayListingMessage(itemId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplyToEbayListingMessageMutationResult = NonNullable<Awaited<ReturnType<typeof replyToEbayListingMessage>>>
    export type ReplyToEbayListingMessageMutationBody = BodyType<ReplyToMessageInput>
    export type ReplyToEbayListingMessageMutationError = ErrorType<ErrorResponse | EbayNotConnectedResponse>

    /**
 * @summary Reply to a buyer's message on an eBay listing
 */
export const useReplyToEbayListingMessage = <TError = ErrorType<ErrorResponse | EbayNotConnectedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replyToEbayListingMessage>>, TError,{itemId: string;data: BodyType<ReplyToMessageInput>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof replyToEbayListingMessage>>,
        TError,
        {itemId: string;data: BodyType<ReplyToMessageInput>},
        TContext
      > => {
      return useMutation(getReplyToEbayListingMessageMutationOptions(options));
    }

export const getEndEbayListingUrl = () => {




  return `/api/ebay/listings/end`
}

/**
 * Ends a live eBay listing before its scheduled end time using the eBay Trading API EndItem call. Requires a connected eBay account.
 *
 * @summary End an active eBay listing early
 */
export const endEbayListing = async (endListingInput: EndListingInput, options?: RequestInit): Promise<EndListingResult> => {

  return customFetch<EndListingResult>(getEndEbayListingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(endListingInput)
  }
);}




export const getEndEbayListingMutationOptions = <TError = ErrorType<ErrorResponse | EbayNotConnectedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endEbayListing>>, TError,{data: BodyType<EndListingInput>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof endEbayListing>>, TError,{data: BodyType<EndListingInput>}, TContext> => {

const mutationKey = ['endEbayListing'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof endEbayListing>>, {data: BodyType<EndListingInput>}> = (props) => {
          const {data} = props ?? {};

          return  endEbayListing(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EndEbayListingMutationResult = NonNullable<Awaited<ReturnType<typeof endEbayListing>>>
    export type EndEbayListingMutationBody = BodyType<EndListingInput>
    export type EndEbayListingMutationError = ErrorType<ErrorResponse | EbayNotConnectedResponse>

    /**
 * @summary End an active eBay listing early
 */
export const useEndEbayListing = <TError = ErrorType<ErrorResponse | EbayNotConnectedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endEbayListing>>, TError,{data: BodyType<EndListingInput>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof endEbayListing>>,
        TError,
        {data: BodyType<EndListingInput>},
        TContext
      > => {
      return useMutation(getEndEbayListingMutationOptions(options));
    }

export const getIngestCardHashesUrl = () => {




  return `/api/card-hash/ingest`
}

/**
 * Downloads each card's artwork image, computes two 64-bit dHash fingerprints (art-zone crop and full-card), and upserts them into the card_hashes table. Idempotent — fully-complete rows (both hashes present) are skipped. Partial rows (phash present, phash_full null) are back-filled with only the missing full-card hash. forceRefresh=true re-downloads and re-hashes everything.
 *
 * @summary Compute and store dHash fingerprints for a set of cards
 */
export const ingestCardHashes = async (ingestCardHashesBody: IngestCardHashesBody, options?: RequestInit): Promise<CardHashIngestResponse> => {

  return customFetch<CardHashIngestResponse>(getIngestCardHashesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ingestCardHashesBody)
  }
);}




export const getIngestCardHashesMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ingestCardHashes>>, TError,{data: BodyType<IngestCardHashesBody>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof ingestCardHashes>>, TError,{data: BodyType<IngestCardHashesBody>}, TContext> => {

const mutationKey = ['ingestCardHashes'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ingestCardHashes>>, {data: BodyType<IngestCardHashesBody>}> = (props) => {
          const {data} = props ?? {};

          return  ingestCardHashes(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IngestCardHashesMutationResult = NonNullable<Awaited<ReturnType<typeof ingestCardHashes>>>
    export type IngestCardHashesMutationBody = BodyType<IngestCardHashesBody>
    export type IngestCardHashesMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Compute and store dHash fingerprints for a set of cards
 */
export const useIngestCardHashes = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ingestCardHashes>>, TError,{data: BodyType<IngestCardHashesBody>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof ingestCardHashes>>,
        TError,
        {data: BodyType<IngestCardHashesBody>},
        TContext
      > => {
      return useMutation(getIngestCardHashesMutationOptions(options));
    }

export const getMatchCardByHashUrl = () => {




  return `/api/card-hash/match`
}

/**
 * Accepts a card photo as a multipart upload. Computes two dHash fingerprints (art-zone and full-card) and returns up to 3 closest candidates from the DB. Dual-signal candidates (both hashes within MEDIUM range) are promoted above single-signal candidates. hammingArtZone and hammingFull expose both distances for tuning; hammingDistance (min of both) remains for backward compatibility.
 *
 * @summary Find the closest card matches for an uploaded photo
 */
export const matchCardByHash = async (matchCardByHashBody: MatchCardByHashBody, options?: RequestInit): Promise<CardHashMatchResponse> => {
    const formData = new FormData();
formData.append(`image`, matchCardByHashBody.image);
if(matchCardByHashBody.setId !== undefined) {
 formData.append(`setId`, matchCardByHashBody.setId);
 }

  return customFetch<CardHashMatchResponse>(getMatchCardByHashUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getMatchCardByHashMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchCardByHash>>, TError,{data: BodyType<MatchCardByHashBody>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof matchCardByHash>>, TError,{data: BodyType<MatchCardByHashBody>}, TContext> => {

const mutationKey = ['matchCardByHash'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchCardByHash>>, {data: BodyType<MatchCardByHashBody>}> = (props) => {
          const {data} = props ?? {};

          return  matchCardByHash(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MatchCardByHashMutationResult = NonNullable<Awaited<ReturnType<typeof matchCardByHash>>>
    export type MatchCardByHashMutationBody = BodyType<MatchCardByHashBody>
    export type MatchCardByHashMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Find the closest card matches for an uploaded photo
 */
export const useMatchCardByHash = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchCardByHash>>, TError,{data: BodyType<MatchCardByHashBody>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof matchCardByHash>>,
        TError,
        {data: BodyType<MatchCardByHashBody>},
        TContext
      > => {
      return useMutation(getMatchCardByHashMutationOptions(options));
    }

export const getIdentifyCardWithVisionUrl = () => {




  return `/api/card-vision/identify`
}

/**
 * Accepts a card photo as a multipart upload and uses Claude claude-haiku-4-5 vision to extract structured card metadata (name, collector number, set code, rarity, HP, types). Used as a fallback when dHash fingerprint matching returns MEDIUM/LOW/no-match confidence. All response fields are nullable — callers must handle partial results. Rate-limited to 20 requests/min/IP.
 *
 * @summary Identify a Pokémon card using Claude vision
 */
export const identifyCardWithVision = async (identifyCardWithVisionBody: IdentifyCardWithVisionBody, options?: RequestInit): Promise<CardVisionResult> => {
    const formData = new FormData();
formData.append(`image`, identifyCardWithVisionBody.image);
if(identifyCardWithVisionBody.setId !== undefined) {
 formData.append(`setId`, identifyCardWithVisionBody.setId);
 }

  return customFetch<CardVisionResult>(getIdentifyCardWithVisionUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getIdentifyCardWithVisionMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identifyCardWithVision>>, TError,{data: BodyType<IdentifyCardWithVisionBody>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof identifyCardWithVision>>, TError,{data: BodyType<IdentifyCardWithVisionBody>}, TContext> => {

const mutationKey = ['identifyCardWithVision'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identifyCardWithVision>>, {data: BodyType<IdentifyCardWithVisionBody>}> = (props) => {
          const {data} = props ?? {};

          return  identifyCardWithVision(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentifyCardWithVisionMutationResult = NonNullable<Awaited<ReturnType<typeof identifyCardWithVision>>>
    export type IdentifyCardWithVisionMutationBody = BodyType<IdentifyCardWithVisionBody>
    export type IdentifyCardWithVisionMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Identify a Pokémon card using Claude vision
 */
export const useIdentifyCardWithVision = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identifyCardWithVision>>, TError,{data: BodyType<IdentifyCardWithVisionBody>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof identifyCardWithVision>>,
        TError,
        {data: BodyType<IdentifyCardWithVisionBody>},
        TContext
      > => {
      return useMutation(getIdentifyCardWithVisionMutationOptions(options));
    }

export const getGetEbayDemandUrl = (params: GetEbayDemandParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ebay/demand?${stringifiedParams}` : `/api/ebay/demand`
}

/**
 * Returns the count of currently active eBay listings and recently sold listings (last 30 days) matching the query. Used by the auction starting-bid suggestion to pick a demand-aware ratio. Uses the eBay Finding API (no OAuth required, only EBAY_CLIENT_ID). When eBay is unconfigured or the lookup fails, both counts are returned as null (HTTP 200) so callers can degrade to an "unknown" tier rather than treating it as a request error.
 *
 * @summary Estimate buyer demand for a search query
 */
export const getEbayDemand = async (params: GetEbayDemandParams, options?: RequestInit): Promise<DemandResult> => {

  return customFetch<DemandResult>(getGetEbayDemandUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEbayDemandQueryKey = (params?: GetEbayDemandParams,) => {
    return [
    `/api/ebay/demand`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEbayDemandQueryOptions = <TData = Awaited<ReturnType<typeof getEbayDemand>>, TError = ErrorType<ErrorResponse>>(params: GetEbayDemandParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEbayDemand>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEbayDemandQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEbayDemand>>> = ({ signal }) => getEbayDemand(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEbayDemand>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEbayDemandQueryResult = NonNullable<Awaited<ReturnType<typeof getEbayDemand>>>
export type GetEbayDemandQueryError = ErrorType<ErrorResponse>


/**
 * @summary Estimate buyer demand for a search query
 */

export function useGetEbayDemand<TData = Awaited<ReturnType<typeof getEbayDemand>>, TError = ErrorType<ErrorResponse>>(
 params: GetEbayDemandParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEbayDemand>>, TError, TData>, }

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEbayDemandQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListLotsUrl = () => {




  return `/api/lots`
}

/**
 * @summary List the signed-in user's purchase lots
 */
export const listLots = async ( options?: RequestInit): Promise<Lot[]> => {

  return customFetch<Lot[]>(getListLotsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLotsQueryKey = () => {
    return [
    `/api/lots`
    ] as const;
    }


export const getListLotsQueryOptions = <TData = Awaited<ReturnType<typeof listLots>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLots>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLotsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLots>>> = ({ signal }) => listLots({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLots>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLotsQueryResult = NonNullable<Awaited<ReturnType<typeof listLots>>>
export type ListLotsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List the signed-in user's purchase lots
 */

export function useListLots<TData = Awaited<ReturnType<typeof listLots>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLots>>, TError, TData>, }

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLotsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateLotUrl = () => {




  return `/api/lots`
}

/**
 * Body uses a client-generated `id` (e.g. "LOT-abc123") so optimistic updates and offline caches keep stable identifiers. `sortingBins` is optional; bins can also be added later via the sub-routes.
 *
 * @summary Create a purchase lot
 */
export const createLot = async (lot: Lot, options?: RequestInit): Promise<Lot> => {

  return customFetch<Lot>(getCreateLotUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lot)
  }
);}




export const getCreateLotMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLot>>, TError,{data: BodyType<Lot>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createLot>>, TError,{data: BodyType<Lot>}, TContext> => {

const mutationKey = ['createLot'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLot>>, {data: BodyType<Lot>}> = (props) => {
          const {data} = props ?? {};

          return  createLot(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLotMutationResult = NonNullable<Awaited<ReturnType<typeof createLot>>>
    export type CreateLotMutationBody = BodyType<Lot>
    export type CreateLotMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a purchase lot
 */
export const useCreateLot = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLot>>, TError,{data: BodyType<Lot>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createLot>>,
        TError,
        {data: BodyType<Lot>},
        TContext
      > => {
      return useMutation(getCreateLotMutationOptions(options));
    }

export const getGetLotUrl = (id: string,) => {




  return `/api/lots/${id}`
}

/**
 * @summary Fetch a single lot
 */
export const getLot = async (id: string, options?: RequestInit): Promise<Lot> => {

  return customFetch<Lot>(getGetLotUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLotQueryKey = (id: string,) => {
    return [
    `/api/lots/${id}`
    ] as const;
    }


export const getGetLotQueryOptions = <TData = Awaited<ReturnType<typeof getLot>>, TError = ErrorType<ErrorResponse>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLot>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLotQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLot>>> = ({ signal }) => getLot(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLot>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLotQueryResult = NonNullable<Awaited<ReturnType<typeof getLot>>>
export type GetLotQueryError = ErrorType<ErrorResponse>


/**
 * @summary Fetch a single lot
 */

export function useGetLot<TData = Awaited<ReturnType<typeof getLot>>, TError = ErrorType<ErrorResponse>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLot>>, TError, TData>, }

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLotQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateLotUrl = (id: string,) => {




  return `/api/lots/${id}`
}

/**
 * sortingBins on the body are ignored — use the sub-routes.
 * @summary Partially update a lot
 */
export const updateLot = async (id: string,
    lotPatch: LotPatch, options?: RequestInit): Promise<Lot> => {

  return customFetch<Lot>(getUpdateLotUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lotPatch)
  }
);}




export const getUpdateLotMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLot>>, TError,{id: string;data: BodyType<LotPatch>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateLot>>, TError,{id: string;data: BodyType<LotPatch>}, TContext> => {

const mutationKey = ['updateLot'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLot>>, {id: string;data: BodyType<LotPatch>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLot(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLotMutationResult = NonNullable<Awaited<ReturnType<typeof updateLot>>>
    export type UpdateLotMutationBody = BodyType<LotPatch>
    export type UpdateLotMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Partially update a lot
 */
export const useUpdateLot = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLot>>, TError,{id: string;data: BodyType<LotPatch>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateLot>>,
        TError,
        {id: string;data: BodyType<LotPatch>},
        TContext
      > => {
      return useMutation(getUpdateLotMutationOptions(options));
    }

export const getDeleteLotUrl = (id: string,) => {




  return `/api/lots/${id}`
}

/**
 * @summary Delete a lot (cascades to its sorting bins; cards keep stale sourceLotId)
 */
export const deleteLot = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLotUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLotMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLot>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteLot>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteLot'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLot>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteLot(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLotMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLot>>>

    export type DeleteLotMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a lot (cascades to its sorting bins; cards keep stale sourceLotId)
 */
export const useDeleteLot = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLot>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteLot>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteLotMutationOptions(options));
    }

export const getCreateSortingBinUrl = (lotId: string,) => {




  return `/api/lots/${lotId}/sorting-bins`
}

/**
 * @summary Add a sorting bin to a lot
 */
export const createSortingBin = async (lotId: string,
    sortingBin: SortingBin, options?: RequestInit): Promise<SortingBin> => {

  return customFetch<SortingBin>(getCreateSortingBinUrl(lotId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sortingBin)
  }
);}




export const getCreateSortingBinMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSortingBin>>, TError,{lotId: string;data: BodyType<SortingBin>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSortingBin>>, TError,{lotId: string;data: BodyType<SortingBin>}, TContext> => {

const mutationKey = ['createSortingBin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSortingBin>>, {lotId: string;data: BodyType<SortingBin>}> = (props) => {
          const {lotId,data} = props ?? {};

          return  createSortingBin(lotId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSortingBinMutationResult = NonNullable<Awaited<ReturnType<typeof createSortingBin>>>
    export type CreateSortingBinMutationBody = BodyType<SortingBin>
    export type CreateSortingBinMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Add a sorting bin to a lot
 */
export const useCreateSortingBin = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSortingBin>>, TError,{lotId: string;data: BodyType<SortingBin>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSortingBin>>,
        TError,
        {lotId: string;data: BodyType<SortingBin>},
        TContext
      > => {
      return useMutation(getCreateSortingBinMutationOptions(options));
    }

export const getUpdateSortingBinUrl = (lotId: string,
    id: string,) => {




  return `/api/lots/${lotId}/sorting-bins/${id}`
}

/**
 * @summary Update a sorting bin
 */
export const updateSortingBin = async (lotId: string,
    id: string,
    sortingBinPatch: SortingBinPatch, options?: RequestInit): Promise<SortingBin> => {

  return customFetch<SortingBin>(getUpdateSortingBinUrl(lotId,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sortingBinPatch)
  }
);}




export const getUpdateSortingBinMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSortingBin>>, TError,{lotId: string;id: string;data: BodyType<SortingBinPatch>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSortingBin>>, TError,{lotId: string;id: string;data: BodyType<SortingBinPatch>}, TContext> => {

const mutationKey = ['updateSortingBin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSortingBin>>, {lotId: string;id: string;data: BodyType<SortingBinPatch>}> = (props) => {
          const {lotId,id,data} = props ?? {};

          return  updateSortingBin(lotId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSortingBinMutationResult = NonNullable<Awaited<ReturnType<typeof updateSortingBin>>>
    export type UpdateSortingBinMutationBody = BodyType<SortingBinPatch>
    export type UpdateSortingBinMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update a sorting bin
 */
export const useUpdateSortingBin = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSortingBin>>, TError,{lotId: string;id: string;data: BodyType<SortingBinPatch>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSortingBin>>,
        TError,
        {lotId: string;id: string;data: BodyType<SortingBinPatch>},
        TContext
      > => {
      return useMutation(getUpdateSortingBinMutationOptions(options));
    }

export const getDeleteSortingBinUrl = (lotId: string,
    id: string,) => {




  return `/api/lots/${lotId}/sorting-bins/${id}`
}

/**
 * @summary Delete a sorting bin
 */
export const deleteSortingBin = async (lotId: string,
    id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteSortingBinUrl(lotId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSortingBinMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSortingBin>>, TError,{lotId: string;id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSortingBin>>, TError,{lotId: string;id: string}, TContext> => {

const mutationKey = ['deleteSortingBin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSortingBin>>, {lotId: string;id: string}> = (props) => {
          const {lotId,id} = props ?? {};

          return  deleteSortingBin(lotId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSortingBinMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSortingBin>>>

    export type DeleteSortingBinMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a sorting bin
 */
export const useDeleteSortingBin = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSortingBin>>, TError,{lotId: string;id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSortingBin>>,
        TError,
        {lotId: string;id: string},
        TContext
      > => {
      return useMutation(getDeleteSortingBinMutationOptions(options));
    }

export const getListCardsUrl = () => {




  return `/api/cards`
}

/**
 * Returns the full card set. Clients filter/search locally — server pagination is a follow-up when an inventory clears 50k records.
 *
 * @summary List all the signed-in user's inventory cards
 */
export const listCards = async ( options?: RequestInit): Promise<Card[]> => {

  return customFetch<Card[]>(getListCardsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCardsQueryKey = () => {
    return [
    `/api/cards`
    ] as const;
    }


export const getListCardsQueryOptions = <TData = Awaited<ReturnType<typeof listCards>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCards>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCardsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCards>>> = ({ signal }) => listCards({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCards>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCardsQueryResult = NonNullable<Awaited<ReturnType<typeof listCards>>>
export type ListCardsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List all the signed-in user's inventory cards
 */

export function useListCards<TData = Awaited<ReturnType<typeof listCards>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCards>>, TError, TData>, }

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCardsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCardUrl = () => {




  return `/api/cards`
}

/**
 * @summary Create a single card
 */
export const createCard = async (card: Card, options?: RequestInit): Promise<Card> => {

  return customFetch<Card>(getCreateCardUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(card)
  }
);}




export const getCreateCardMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCard>>, TError,{data: BodyType<Card>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCard>>, TError,{data: BodyType<Card>}, TContext> => {

const mutationKey = ['createCard'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCard>>, {data: BodyType<Card>}> = (props) => {
          const {data} = props ?? {};

          return  createCard(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCardMutationResult = NonNullable<Awaited<ReturnType<typeof createCard>>>
    export type CreateCardMutationBody = BodyType<Card>
    export type CreateCardMutationError = ErrorType<unknown>

    /**
 * @summary Create a single card
 */
export const useCreateCard = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCard>>, TError,{data: BodyType<Card>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCard>>,
        TError,
        {data: BodyType<Card>},
        TContext
      > => {
      return useMutation(getCreateCardMutationOptions(options));
    }

export const getBulkCreateCardsUrl = () => {




  return `/api/cards/bulk`
}

/**
 * @summary Bulk-create cards (mirror of AppContext.addCards)
 */
export const bulkCreateCards = async (card: Card[], options?: RequestInit): Promise<Card[]> => {

  return customFetch<Card[]>(getBulkCreateCardsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(card)
  }
);}




export const getBulkCreateCardsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCreateCards>>, TError,{data: BodyType<Card[]>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkCreateCards>>, TError,{data: BodyType<Card[]>}, TContext> => {

const mutationKey = ['bulkCreateCards'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkCreateCards>>, {data: BodyType<Card[]>}> = (props) => {
          const {data} = props ?? {};

          return  bulkCreateCards(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkCreateCardsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkCreateCards>>>
    export type BulkCreateCardsMutationBody = BodyType<Card[]>
    export type BulkCreateCardsMutationError = ErrorType<unknown>

    /**
 * @summary Bulk-create cards (mirror of AppContext.addCards)
 */
export const useBulkCreateCards = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCreateCards>>, TError,{data: BodyType<Card[]>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkCreateCards>>,
        TError,
        {data: BodyType<Card[]>},
        TContext
      > => {
      return useMutation(getBulkCreateCardsMutationOptions(options));
    }

export const getBulkPatchCardsUrl = () => {




  return `/api/cards/bulk`
}

/**
 * @summary Bulk patch (mirror of AppContext.bulkUpdateCards)
 */
export const bulkPatchCards = async (bulkCardPatch: BulkCardPatch[], options?: RequestInit): Promise<Card[]> => {

  return customFetch<Card[]>(getBulkPatchCardsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkCardPatch)
  }
);}




export const getBulkPatchCardsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkPatchCards>>, TError,{data: BodyType<BulkCardPatch[]>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkPatchCards>>, TError,{data: BodyType<BulkCardPatch[]>}, TContext> => {

const mutationKey = ['bulkPatchCards'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkPatchCards>>, {data: BodyType<BulkCardPatch[]>}> = (props) => {
          const {data} = props ?? {};

          return  bulkPatchCards(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkPatchCardsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkPatchCards>>>
    export type BulkPatchCardsMutationBody = BodyType<BulkCardPatch[]>
    export type BulkPatchCardsMutationError = ErrorType<unknown>

    /**
 * @summary Bulk patch (mirror of AppContext.bulkUpdateCards)
 */
export const useBulkPatchCards = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkPatchCards>>, TError,{data: BodyType<BulkCardPatch[]>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkPatchCards>>,
        TError,
        {data: BodyType<BulkCardPatch[]>},
        TContext
      > => {
      return useMutation(getBulkPatchCardsMutationOptions(options));
    }

export const getBulkDeleteCardsUrl = () => {




  return `/api/cards/bulk`
}

/**
 * @summary Bulk-delete cards by id
 */
export const bulkDeleteCards = async (bulkDeleteIds: BulkDeleteIds, options?: RequestInit): Promise<BulkDeleteResult> => {

  return customFetch<BulkDeleteResult>(getBulkDeleteCardsUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkDeleteIds)
  }
);}




export const getBulkDeleteCardsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteCards>>, TError,{data: BodyType<BulkDeleteIds>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteCards>>, TError,{data: BodyType<BulkDeleteIds>}, TContext> => {

const mutationKey = ['bulkDeleteCards'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkDeleteCards>>, {data: BodyType<BulkDeleteIds>}> = (props) => {
          const {data} = props ?? {};

          return  bulkDeleteCards(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkDeleteCardsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDeleteCards>>>
    export type BulkDeleteCardsMutationBody = BodyType<BulkDeleteIds>
    export type BulkDeleteCardsMutationError = ErrorType<unknown>

    /**
 * @summary Bulk-delete cards by id
 */
export const useBulkDeleteCards = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteCards>>, TError,{data: BodyType<BulkDeleteIds>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkDeleteCards>>,
        TError,
        {data: BodyType<BulkDeleteIds>},
        TContext
      > => {
      return useMutation(getBulkDeleteCardsMutationOptions(options));
    }

export const getUpdateCardUrl = (id: string,) => {




  return `/api/cards/${id}`
}

/**
 * @summary Partially update a card
 */
export const updateCard = async (id: string,
    cardPatch: CardPatch, options?: RequestInit): Promise<Card> => {

  return customFetch<Card>(getUpdateCardUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cardPatch)
  }
);}




export const getUpdateCardMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCard>>, TError,{id: string;data: BodyType<CardPatch>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateCard>>, TError,{id: string;data: BodyType<CardPatch>}, TContext> => {

const mutationKey = ['updateCard'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCard>>, {id: string;data: BodyType<CardPatch>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCard(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCardMutationResult = NonNullable<Awaited<ReturnType<typeof updateCard>>>
    export type UpdateCardMutationBody = BodyType<CardPatch>
    export type UpdateCardMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Partially update a card
 */
export const useUpdateCard = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCard>>, TError,{id: string;data: BodyType<CardPatch>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCard>>,
        TError,
        {id: string;data: BodyType<CardPatch>},
        TContext
      > => {
      return useMutation(getUpdateCardMutationOptions(options));
    }

export const getDeleteCardUrl = (id: string,) => {




  return `/api/cards/${id}`
}

/**
 * @summary Delete a card
 */
export const deleteCard = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCardUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCardMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCard>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCard>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCard'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCard>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCard(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCardMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCard>>>

    export type DeleteCardMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a card
 */
export const useDeleteCard = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCard>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCard>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteCardMutationOptions(options));
    }

export const getListStorageBinsUrl = () => {




  return `/api/storage-bins`
}

/**
 * @summary List the user's storage bins
 */
export const listStorageBins = async ( options?: RequestInit): Promise<StorageBin[]> => {

  return customFetch<StorageBin[]>(getListStorageBinsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStorageBinsQueryKey = () => {
    return [
    `/api/storage-bins`
    ] as const;
    }


export const getListStorageBinsQueryOptions = <TData = Awaited<ReturnType<typeof listStorageBins>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStorageBins>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStorageBinsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStorageBins>>> = ({ signal }) => listStorageBins({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStorageBins>>, TError, TData> & { queryKey: QueryKey }
}

export type ListStorageBinsQueryResult = NonNullable<Awaited<ReturnType<typeof listStorageBins>>>
export type ListStorageBinsQueryError = ErrorType<unknown>


/**
 * @summary List the user's storage bins
 */

export function useListStorageBins<TData = Awaited<ReturnType<typeof listStorageBins>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStorageBins>>, TError, TData>, }

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListStorageBinsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateStorageBinUrl = () => {




  return `/api/storage-bins`
}

/**
 * @summary Create a storage bin
 */
export const createStorageBin = async (storageBin: StorageBin, options?: RequestInit): Promise<StorageBin> => {

  return customFetch<StorageBin>(getCreateStorageBinUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(storageBin)
  }
);}




export const getCreateStorageBinMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStorageBin>>, TError,{data: BodyType<StorageBin>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createStorageBin>>, TError,{data: BodyType<StorageBin>}, TContext> => {

const mutationKey = ['createStorageBin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStorageBin>>, {data: BodyType<StorageBin>}> = (props) => {
          const {data} = props ?? {};

          return  createStorageBin(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStorageBinMutationResult = NonNullable<Awaited<ReturnType<typeof createStorageBin>>>
    export type CreateStorageBinMutationBody = BodyType<StorageBin>
    export type CreateStorageBinMutationError = ErrorType<unknown>

    /**
 * @summary Create a storage bin
 */
export const useCreateStorageBin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStorageBin>>, TError,{data: BodyType<StorageBin>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createStorageBin>>,
        TError,
        {data: BodyType<StorageBin>},
        TContext
      > => {
      return useMutation(getCreateStorageBinMutationOptions(options));
    }

export const getUpdateStorageBinUrl = (id: string,) => {




  return `/api/storage-bins/${id}`
}

/**
 * @summary Update a storage bin (name and/or color)
 */
export const updateStorageBin = async (id: string,
    storageBinPatch: StorageBinPatch, options?: RequestInit): Promise<StorageBin> => {

  return customFetch<StorageBin>(getUpdateStorageBinUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(storageBinPatch)
  }
);}




export const getUpdateStorageBinMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStorageBin>>, TError,{id: string;data: BodyType<StorageBinPatch>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateStorageBin>>, TError,{id: string;data: BodyType<StorageBinPatch>}, TContext> => {

const mutationKey = ['updateStorageBin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStorageBin>>, {id: string;data: BodyType<StorageBinPatch>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateStorageBin(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateStorageBinMutationResult = NonNullable<Awaited<ReturnType<typeof updateStorageBin>>>
    export type UpdateStorageBinMutationBody = BodyType<StorageBinPatch>
    export type UpdateStorageBinMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update a storage bin (name and/or color)
 */
export const useUpdateStorageBin = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStorageBin>>, TError,{id: string;data: BodyType<StorageBinPatch>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateStorageBin>>,
        TError,
        {id: string;data: BodyType<StorageBinPatch>},
        TContext
      > => {
      return useMutation(getUpdateStorageBinMutationOptions(options));
    }

export const getDeleteStorageBinUrl = (id: string,) => {




  return `/api/storage-bins/${id}`
}

/**
 * @summary Delete a storage bin
 */
export const deleteStorageBin = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteStorageBinUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteStorageBinMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStorageBin>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteStorageBin>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteStorageBin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStorageBin>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteStorageBin(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteStorageBinMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStorageBin>>>

    export type DeleteStorageBinMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a storage bin
 */
export const useDeleteStorageBin = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStorageBin>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteStorageBin>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteStorageBinMutationOptions(options));
    }

